import React from 'react';
import withIpGeoLocationData from 'containers/withIpGeoLocationData';
import { isMobileApp } from 'utils/mode';
import { parseQuery } from 'utils/web';
import DefaultLandingPage from './DefaultLandingPage';

const DEFAULT_PAGE = DefaultLandingPage;
const PROMOTION_PAGES = {
  //bethlehem: BethlehemLandingPage
};
const DISABLE_IP_GEOLOCATION = !Object.keys(PROMOTION_PAGES).length;

function LandingPage({ ipGeoLocationData, location }) {
  let zone;
  if (!DISABLE_IP_GEOLOCATION) {
    if (!ipGeoLocationData.ipGeoLocationData && ipGeoLocationData.loading) {
      return null;
    }

    const overrideZone = parseQuery(location.search).promotion;
    const data = ipGeoLocationData.ipGeoLocationData;
    zone = overrideZone || (data && data.promotionZone);
  }

  const Component = (zone && PROMOTION_PAGES[zone]) || DEFAULT_PAGE;
  if (isMobileApp() && Component === DEFAULT_PAGE) {
    // Mobile app shouldn't display default landing page
    return null;
  }
  return <Component />;
}

export default withIpGeoLocationData({
  skip: DISABLE_IP_GEOLOCATION
})(LandingPage);
